export default function saveStateToStorage<T>(key: string, value: T[keyof T]) {
  if (value) window.localStorage.setItem(key, JSON.stringify(value))
  else window.localStorage.removeItem(key)
}
